var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 10.125L8.64962 15.6316C8.42487 15.8564 8.3125 16.1198 8.3125 16.4219C8.3125 16.724 8.42708 16.9946 8.65625 17.2337C8.88542 17.4529 9.15104 17.5625 9.45312 17.5625C9.75521 17.5625 10.0188 17.4498 10.244 17.2243L17.6749 9.78413C17.7875 9.6714 17.8698 9.54927 17.9219 9.41775C17.974 9.28623 18 9.14531 18 8.995C18 8.84471 17.974 8.7038 17.9219 8.57228C17.8698 8.44076 17.7917 8.32292 17.6875 8.21875L10.25 0.78125C10.0208 0.552083 9.75347 0.4375 9.44791 0.4375C9.14236 0.4375 8.87848 0.552083 8.65625 0.78125C8.42708 1.00348 8.3125 1.26736 8.3125 1.57291C8.3125 1.87847 8.42543 2.14418 8.65128 2.37003L14.1562 7.875H1.59297C1.27445 7.875 1.00745 7.98218 0.791968 8.19653C0.576489 8.41091 0.46875 8.67653 0.46875 8.99341C0.46875 9.3103 0.576489 9.57812 0.791968 9.79688C1.00745 10.0156 1.27445 10.125 1.59297 10.125H14.1562Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/iconRight.18e82d854c50d2db8476d5498b82f9ab.svg";
export { ForwardRef as ReactComponent };